import type { JSX } from 'react';
import type { SessionSummary } from '@teams-avatar/shared';

/**
 * Teams kann den Bot in die Lobby stellen. Ohne deutlichen Hinweis suchen
 * Mitarbeiter den Fehler im System, obwohl nur jemand im Meeting zulassen muss.
 *
 * Deshalb dunkel und nicht als weitere weisse Karte: das ist die einzige Stelle
 * der Oberflaeche, die eine Handlung ausserhalb dieser Oberflaeche verlangt.
 */
export function LobbyBanner({ sessions }: { sessions: SessionSummary[] }): JSX.Element | null {
  if (sessions.length === 0) return null;

  return (
    <div className="rounded-xl bg-bg-dark p-4 sm:p-5" role="status">
      <p className="flex items-center gap-2 text-base font-medium text-brand">
        <span aria-hidden="true" className="h-2 w-2 animate-pulse rounded-full bg-brand" />
        {sessions.length === 1
          ? 'AVA wartet in der Lobby.'
          : `${sessions.length} AVAs warten in der Lobby.`}
      </p>
      <p className="mt-2 text-sm text-fg-on-dark">
        Teams laesst AVA nicht automatisch herein. Bitte im Meeting auf
        „Zulassen“ klicken — hier ist nichts kaputt.
      </p>
      <ul className="mt-3 space-y-1 text-sm text-fg-on-dark-muted">
        {sessions.map((session) => (
          <li key={session.id}>
            <span className="font-medium text-fg-on-dark">{session.displayName}</span>
            {' — '}
            {session.meetingLabel}
            {' · gestartet von '}
            {session.startedBy}
          </li>
        ))}
      </ul>
    </div>
  );
}
